module.exports = __webpack_public_path__ + "img/logo-dorfladen-full.8b22af36.png";